module.exports = __webpack_public_path__ + "assets/images/Favicon.6a33aed0dea3f40876401b14b384d814.png";